(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/betslip/assets/javascripts/betslip-context.js') >= 0) return;  svs.modules.push('/components/lb-ui/betslip/assets/javascripts/betslip-context.js');
"use strict";


const _React = React,
  createContext = _React.createContext;
const BetslipContext = createContext();
setGlobal('svs.components.lbUi.betslip.BetslipContext', BetslipContext);

 })(window);